// src/dashboard.js - Updated with Three-Tier Storage Panel
import React, { useState } from "react";
import {
  Grid,
  Box,
  CircularProgress,
} from "@mui/material";
import { useEnvironment } from "./context/EnvironmentContext";
import FraudAlertsPanel from "./components/fraudMatch/FraudAlertsPanel";
import CardDeclinesPanel from "./components/paymentTracking/CardDeclinesPanel";
import CardDeclineHistoryPanel from "./components/paymentTracking/CardDeclineHistoryPanel";
import CacheControlPanel from "./components/common/CacheControlPanel";
import DebugPanel from "./components/common/DebugPanel";
import ErrorBoundary from "./components/common/ErrorBoundary";
import FraudWarningsPanel from "./components/fraudWarnings/FraudWarningsPanel";
import KVStorageCleanupPanel from "./components/cleanup/KVstorageCleanup";
import ThreeTierStoragePanel from "./components/storage/ThreeTierStoragePanel"; // NEW
import PaymentTrackingDebugPanel from "./components/paymentTracking/PaymentTrackingDebugPanel";
import PaymentFlowAnalyzer from "./components/paymentTracking/PaymentFlowAnalyzer";
import RequestMonitor from "./components/paymentTracking/RequestMonitor";
import InternationalOrdersPanel from "./components/international/InternationalOrdersPanel";
import PayaReviewPanel from "./components/paya/PayaReviewPanel";

const Dashboard = ({ onLogout }) => {
  const { environment, isLoading } = useEnvironment();

  // Helper function to determine if developer tools should show
  const showDevTools = () => {
    // Show dev tools in staging or if explicitly enabled
    return (
      environment === "staging" ||
      localStorage.getItem("showDevTools") === "true" ||
      window.location.hostname === "localhost"
    );
  };

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="200px"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%", p: 0 }}>
      <Grid container spacing={3}>
        {/* Statistics Panel */}
        <Grid item xs={12} sx={{ width: "100%" }}></Grid>

        {/* Fraud Warnings Panel */}
        <Grid item xs={12} sx={{ width: "100%" }}>
          <ErrorBoundary component="FraudWarningsPanel">
            <FraudWarningsPanel />
          </ErrorBoundary>
        </Grid>

        {/* Fraud Alerts + Card Declines — grouped with no gap */}
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 0, mb: 3 }}>
          <Grid item xs={12} sx={{ width: "100%" }}>
            <ErrorBoundary component="FraudAlertsPanel">
              <FraudAlertsPanel />
            </ErrorBoundary>
          </Grid>
          <Grid item xs={12} sx={{ width: "100%" }}>
            <ErrorBoundary component="CardDeclinesPanel">
              <CardDeclinesPanel />
            </ErrorBoundary>
          </Grid>
        </Box>

        {/* Card Decline History Panel */}
        <Grid item xs={12} sx={{ width: "100%" }}>
          <ErrorBoundary component="CardDeclineHistoryPanel">
            <CardDeclineHistoryPanel />
          </ErrorBoundary>
        </Grid>

        {/* International Orders Panel */}
        <Grid item xs={12} sx={{ width: "100%" }}>
          <ErrorBoundary component="InternationalOrdersPanel">
            <InternationalOrdersPanel />
          </ErrorBoundary>
        </Grid>

        {/* Paya Transaction Review Panel */}
        <Grid item xs={12} sx={{ width: "100%" }}>
          <ErrorBoundary component="PayaReviewPanel">
            <PayaReviewPanel />
          </ErrorBoundary>
        </Grid>

        {/* NEW: Three-Tier Storage Panel */}
        <Grid item xs={12} sx={{ width: "100%" }}>
          <ErrorBoundary component="ThreeTierStoragePanel">
            <ThreeTierStoragePanel />
          </ErrorBoundary>
        </Grid>

        {/* Developer Tools - Only show in development mode */}
        {showDevTools() && (
          <>
            {/* KV Storage Cleanup Panel */}
            <Grid item xs={12} sx={{ width: "100%" }}>
              <ErrorBoundary component="KVStorageCleanupPanel">
                <KVStorageCleanupPanel />
              </ErrorBoundary>
            </Grid>

            {/* Debug  Payment Panel */}
            <Grid item xs={12} sx={{ width: "100%" }}>
              <ErrorBoundary component="RequestMonitorPanel">
                <RequestMonitor />
              </ErrorBoundary>
            </Grid>

            {/* Debug  Payment Panel */}
            <Grid item xs={12} sx={{ width: "100%" }}>
              <ErrorBoundary component="PaymentFlowPanel">
                <PaymentFlowAnalyzer />
              </ErrorBoundary>
            </Grid>

            {/* Debug  Payment Panel */}
            <Grid item xs={12} sx={{ width: "100%" }}>
              <ErrorBoundary component="DebugPaymentPanel">
                <PaymentTrackingDebugPanel />
              </ErrorBoundary>
            </Grid>

            {/* Cache Control Panel */}
            <Grid item xs={12} sx={{ width: "100%" }}>
              <ErrorBoundary component="CacheControlPanel">
                <CacheControlPanel
                  onClearCache={() => {
                    window.location.reload();
                  }}
                />
              </ErrorBoundary>
            </Grid>

            {/* Debug Panel */}
            <Grid item xs={12} sx={{ width: "100%" }}>
              <ErrorBoundary component="DebugPanel">
                <DebugPanel />
              </ErrorBoundary>
            </Grid>
          </>
        )}

        {/* Add more panels here later */}
      </Grid>
    </Box>
  );
};

export default Dashboard;
